<template>
  <div id="calendar">
    <div class="inner_calendar">
      <ul class="calendar_events">
        <li class="calendar_item" v-for="(event, index) in $store.state.list_courses" :key="index">
          <div class="inner_calendar_item">
            <div class="date_container">
              <p class="month">{{ event.date_calendar_view[0] }}</p>
              <p class="year">{{ event.date_calendar_view[1] }}</p>
            </div>
            <div class="infos_container">
              <p class="course_name">{{ event.name }}</p>
              <a :href="'/challenge-maritima/courses/#' + event.anchor"><b-button class="infos_btn">En savoir plus</b-button></a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
